var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-transfer-certificate',{attrs:{"disabled":false}}),_c('form-contract-client-e-e',{attrs:{"disabled":false}}),_c('form-specific-plan-prevention'),_c('form-contract-provider-e-e')],1)}
var staticRenderFns = []

export { render, staticRenderFns }